/**
 * @type {{data: null | RoiGateFormData}}
 */
const roiGateFormDataStore = {data: null};

module.exports = roiGateFormDataStore;